import { render, staticRenderFns } from "./IconEdfMobile.vue?vue&type=template&id=894aa58e&scoped=true&"
import script from "./IconEdfMobile.vue?vue&type=script&lang=js&"
export * from "./IconEdfMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894aa58e",
  null
  
)

export default component.exports